import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 850;
const RESULTS_BREAKPOINT = 960;

function getResponsiveState() {
  if (typeof window === 'undefined') {
    return { isMobile: false };
  }

  const width = window.innerWidth;
  return {
    isMobile: width <= MOBILE_BREAKPOINT,
  };
}

/**
 * Calcula la cantidad inicial de resultados a mostrar basándose en el viewport
 * y la longitud real del array de hits.
 * @param {number} hitsLength - Longitud del array de hits del servicio
 * @returns {number} Cantidad de resultados a mostrar inicialmente
 */
export function getInitialResultsCount(hitsLength) {
  if (typeof window === 'undefined') {
    return 3;
  }

  const width = window.innerWidth;
  const maxResults = width <= RESULTS_BREAKPOINT ? 10 : 3;
  
  // Retorna el mínimo entre el máximo calculado y la longitud real de hits
  return Math.min(maxResults, hitsLength);
}

/** Centraliza los breakpoints usados por la búsqueda y sus paneles. */
export function useResponsive() {
  const [responsive, setResponsive] = useState(getResponsiveState);

  useEffect(() => {
    const updateResponsiveState = () => {
      const nextState = getResponsiveState();
      setResponsive(previous => (
        previous.isMobile === nextState.isMobile
          ? previous
          : nextState
      ));
    };

    window.addEventListener('resize', updateResponsiveState);
    return () => window.removeEventListener('resize', updateResponsiveState);
  }, []);

  return responsive;
}
